import {phoneRegExp} from "@/constants/common";
import * as yup from "yup";


export const contactSchemaPassenger = yup.object({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  phone: yup
    .string()
    .matches(phoneRegExp, "Invalid phone number")
    .required("Phone number is required"),
  companyName: yup.string().optional(),
  subject: yup.string().optional(),
  question: yup.string().required("Question is required"),
});

export type ContactSchemaPassenger = yup.InferType<typeof contactSchemaPassenger>;

